export const name = "ST_SNAPTOGRID";
export const summary = `Produces a \`GEOGRAPHY\` value, where each vertex has been snapped to a longitude/latitude grid.`;
export const reference = `
## ST_SNAPTOGRID

Produces a \`GEOGRAPHY\` value, where each vertex has been snapped to a longitude/latitude grid.

\`\`\`
ST_SNAPTOGRID(geography_expression, grid_size)
\`\`\`

### Description

Returns the input \`GEOGRAPHY\`, where each vertex has been snapped to a longitude/latitude grid. The grid size is determined by the\`grid_size\` parameter which is given in degrees.


### Constraints

Arbitrary grid sizes aren't supported. The \`grid_size\` parameter is rounded so that it's of the form \`10^n\`, where \`-10 < n < 0\`.


### Return type

\`GEOGRAPHY\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
